<script lang="ts">
import { isLanguage } from '../i18n.svelte'

export let src_ja = ''
export let src_en = ''
export let alt_ja = ''
export let alt_en = ''
</script>
<template lang="pug">
+if('isLanguage("ja")')
    img(src="{src_ja}", alt="{alt_ja}")
    +else
        img(src="{src_en}", alt="{alt_en}")
</template>